import Vue from 'vue'
let eventBus=new Vue();
let obj={
  connect(callback,config={}) {
    if (this.isSupportWs()) {
      let me=this;
      let port = config.port || '9876';
      let url = 'ws://' + window.location.hostname + ':' + port;
      let ws =this.ws= new WebSocket(url);
      ws.onopen=function(){
        if(callback){
          callback();
        }else{
          //没有传回调的时候，直接初始化当前用户
          MessageCenter.send({cmd:"init",category:PF.userInfo.inituserid});
        }
      };
      ws.onmessage = function (e)
      {
        let obj=JSON.parse(e.data);
        if (obj.type === "Notification") {
          eventBus.$notify({
            title: obj.title || '',
            message: obj.msg,
            position: 'bottom-right'
          });
        }
        eventBus.$emit("message",obj);
      };
      ws.onerror=function(){
        eventBus.$emit("error");
      }
      ws.onclose=function(){
        setTimeout(function(){me.connect();},3000)
      };
    }
  },
  isSupportWs() {
    return !!window.WebSocket;
  },
  markRead(messageId){
    return PF.invoke("s:sms.srv.markRead",messageId);
  },
  on(){
    eventBus.$on.apply(eventBus, arguments);
  },
  off() {
    eventBus.$off.apply(eventBus, arguments);
  },
  once() {
    eventBus.$once.apply(eventBus, arguments);
  },
  send(msg){
    if (typeof(msg) !== 'string') {
      msg=JSON.stringify(msg)
    }
    this.ws.send(msg);
  }
};
window.MessageCenter=obj;
export default obj;



// WEBPACK FOOTER //
// ./src/common/utils/messageCenter.js